<template>
    <sui-modal
            v-model="showModalDialog"
            style="z-index: 21000;"
            :closable="false"
    >
        <sui-modal-header>Параметры заявки</sui-modal-header>
        <sui-modal-content scrolling>
            <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
            >
                <v-container>
                    <v-layout row wrap>
                        <v-flex xs12 sm12>
                            <v-text-field
                                    label="Заказчик"
                                    color="blue darken-2"
                                    v-model="entity.customer"
                                    :rules="[v => !!v || 'Обязательное поле']"
                            />
                        </v-flex>
                        <v-flex xs12 sm12
                                :style="{'padding-bottom': '0px'}">
                            <v-subheader
                                    :style="{height: 'auto',padding: '0px', 'cursor': 'default'}">
                                Уполномоченный представитель заказчика
                            </v-subheader>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-divider/>
                        </v-flex>
                        <v-flex xs12 sm4>
                            <v-text-field
                                    label="И.О. Фамилия"
                                    color="blue darken-2"
                                    v-model="entity.customerRepresentativeFullName"
                                    :rules="[v => !!v || 'Обязательное поле']"
                                    required
                            />
                        </v-flex>
                        <v-flex xs12 sm4>
                            <v-text-field
                                    label="Телефон"
                                    color="blue darken-2"
                                    v-model="entity.customerRepresentativePhone"
                                    :rules="[v => !!v || 'Обязательное поле']"
                                    required
                            />
                        </v-flex>

                        <v-flex xs12 sm4>
                            <v-text-field
                                    label="E-mail"
                                    color="blue darken-2"
                                    v-model="entity.customerRepresentativeEmail"
                                    :rules="[v => !!v || 'Обязательное поле']"
                                    required
                            />
                        </v-flex>

                        <v-flex xs12 sm12
                                :style="{'padding-bottom': '0px'}">
                            <v-subheader
                                    :style="{height: 'auto',padding: '0px', 'cursor': 'default'}">
                                Параметры по умолчанию для районов наблюдения
                            </v-subheader>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-divider/>
                        </v-flex>

                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="Периодичность съемки"
                                    color="blue darken-2"
                                    type="number"
                                    v-model="entity.defShootingFrequency"
                                    :rules="[v => !!v || 'Обязательное поле']"
                                    required
                            />
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="Диапазон допустимых углов Солнца"
                                    color="blue darken-2"
                                    v-model="entity.defSunAnglesRange"
                                    :rules="[v => !!v || 'Обязательное поле']"
                                    required
                            />
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="Приоритет территории"
                                    color="blue darken-2"
                                    type="number"
                                    v-model="entity.defTerritoryPriority"
                                    :rules="[v => !!v || 'Обязательное поле']"
                                    required
                            />
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="Максимально допустимый угол крена"
                                    color="blue darken-2"
                                    type="number"
                                    v-model="entity.defMaxRollAngle"
                                    :rules="[v => !!v || 'Обязательное поле']"
                                    required
                            />
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="Уровень обработки"
                                    color="blue darken-2"
                                    type="number"
                                    v-model="entity.defProcessingLevel"
                                    :rules="[v => !!v || 'Обязательное поле']"
                                    required
                            />
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="Примечание"
                                    color="blue darken-2"
                                    v-model="entity.defNote"
                            />
                        </v-flex>
                        <v-flex xs12 sm12
                                :style="{'padding-bottom': '0px'}">
                            <v-subheader
                                    :style="{height: 'auto',padding: '0px','cursor': 'default'}">
                                Параметры письма
                            </v-subheader>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-divider/>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-text-field
                                    label="Заголовок"
                                    color="blue darken-2"
                                    v-model="entity.letterHeader"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-textarea
                                    label="Текст письма"
                                    color="blue darken-2"
                                    v-model="entity.letterText"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </sui-modal-content>
        <sui-modal-actions>
            <v-btn round color="blue darken-2" dark
                   :disabled="!valid"
                   @click="onSaveButtonClick"
            >
                сохранить
            </v-btn>
            <v-btn round flat
                   @click="showModalDialog=false"
            >
                отмена
            </v-btn>
        </sui-modal-actions>
    </sui-modal>
</template>

<script>
    import Vue from 'vue'

    export default {
        props: {
            value: {
                type: Object,
                default: () => ({})
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showModalDialog: this.show,
                entity: this.copyEntity(this.value),
                valid: true
            }
        },
        computed: {},
        methods: {
            onSaveButtonClick() {
                if (this.$refs.form.validate()) {
                    this.$emit('configUpdated', this.entity);
                    this.showModalDialog = false;
                }
            },
            copyEntity(val) {
                return Object.assign({}, {
                    customer: null,
                    customerRepresentativeFullName: null,
                    customerRepresentativePhone: null,
                    customerRepresentativeEmail: null,
                    defShootingFrequency: null,
                    defSunAnglesRange: null,
                    defTerritoryPriority: null,
                    defMaxRollAngle: null,
                    defProcessingLevel: null,
                    defNote: null,
                    letterHeader: null,
                    letterText: null
                }, val || {})
            }
        },

        components: {},
        watch: {
            show(newVal) {
                this.showModalDialog = newVal;
            },
            showModalDialog(newVal) {
                this.$emit('update:show', newVal);
            },
            value(newVal) {
                this.entity = this.copyEntity(newVal);
            }
        }

    }
</script>

<style>

</style>
